import { ListProvider } from "./list-provider";
import { Lookup } from "../../../../business-objects/lookup/lookup.model";
import { LookupStoreFacade } from "../../../../business-objects/lookup/lookup.store-facade";
import { Observable } from "rxjs/Observable";
import { ListPickerControlModalItemModel } from "../list-picker-control-modal-item.model";

export class LookupListProvider extends ListProvider<Lookup> {

    getFacade(): LookupStoreFacade {
        return this.appFacade.objects.lookup.store;
    }

    getPrimaryField(item: Lookup): string {
        return item && item.title;
    }

    getSecondaryField(item: Lookup): string {
        return item && item.title;
    }

    getList(lookupType): Observable<Array<ListPickerControlModalItemModel>> {
        return this.getFacade()
            .getAll()
            .map(items => items.filter(item => item.lookupType === lookupType))

            .map(items => items.map(item => new ListPickerControlModalItemModel(item.id, this.getPrimaryField(item))));
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/lookup-list-provider.ts